import React from 'react';
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
// import { COLORS } from './Colors.js'
import { Line, Line2, Header, TwoColumn, WideImage, SingleColumn, Box, ImageArray, Accordion, BoxImage } from './Elements.js'

const components = {
  "Header": Header,
  "Line": Line,
  "Line2": Line2,
  "TwoColumn": TwoColumn,
  "WideImage": WideImage,
  "SingleColumn": SingleColumn,
  "Box": Box,
  "BoxImage": BoxImage,
  "ImageArray": ImageArray,
  "Accordion": Accordion,
};

const Definition = ({ currentPage, sectionColor, children, ...props }) => {

  const { lang } = useParams();
  const { t, i18n } = useTranslation();

  // Change the language dynamically
  React.useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang, i18n]);

  const sections = t(currentPage, { returnObjects: true })
  const sectionKeys = Object.keys(sections);

  const sectionHero = sections["hero"]

  return (
    <div>
      {sectionHero && (sectionHero.subtitle || sectionHero.h1) && <Header
        sectionKey={sectionKeys[0]}
        sectionContent={sectionHero}
        sectionColor={sectionColor}
        EnumerateTag={("EnumerateTag" in sectionHero) ? sectionHero.EnumerateTag : 'li'}
      />}

      {sectionKeys.map((section, i) => {
        const sectionContent = sections[section]

        if (i === 0) {
          return <div key="0">{children}</div>
        }

        const Element = ("element" in sectionContent) ? components[sectionContent.element] : Line

        return <Element
          key={i}
          sectionKey={section}
          sectionContent={sectionContent}
          sectionBackgroundCss={sectionContent.sectionBackgroundCss}
          sectionColor={("color" in sectionContent) ? sectionContent.color : sectionColor}
          EnumerateTag={("EnumerateTag" in sectionContent) ? sectionContent.EnumerateTag : 'p'}
          alignLeft={("align" in sectionContent) ? sectionContent.align : true}
          textAlign={sectionContent.textAlign}
          {...props}
        />
      })}
    </div>
  );
};

export default Definition;